<script setup lang="ts">

import ATitle from "~/components/design/type/ATitle.vue";
import ABlurb from "~/components/design/type/ABlurb.vue";
import ActionButton from "~/components/design/buttons/ActionButton.vue";

defineProps({
  leadingText: String,
  align: {
    type: String,
    default() {
      return 'left'
    }
  },
  type: {
    type: String,
    default() {
      return 'h2'
    }
  },
  titleColor: {
    type: String,
    default() {
      return 'primary'
    }
  },
  blurbColor: {
    type: String,
    default() {
      return 'text'
    }
  },
  title: String,
  blurb: String,
  buttonText: String,
  to: String
});
</script>

<template>
  <div class="a-feature">
    <a-title class="mb-4" :leading-text="leadingText" :align="align" :color="titleColor" :type="type" :text="title">
      <slot name="title">
        {{ title }}
      </slot>
    </a-title>
    <a-blurb class="mb-8" :align="align" :color="blurbColor" :text="blurb">
      <slot name="blurb">
      {{ blurb }}
      </slot>
    </a-blurb>
    <div :class="'text-'+align">
      <action-button class="mb-4" :align="align" color="accent" v-if="buttonText" :text="buttonText" :to="to"/>
    </div>
  </div>
</template>

<style scoped>

</style>
